import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { Observable, ReplaySubject } from 'rxjs';

import { Store } from '@ngrx/store';

import { Location } from '@era/locations-sdk';

import { CategoryStoreSelectors } from '@era/stores';
import { LocationSelectComponent } from './location-select.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'era-location-select',
  templateUrl: './location-select.container.html',
  styleUrls: ['./location-select.container.scss'],
  imports: [LocationSelectComponent, AsyncPipe],
})
export class LocationSelectContainerComponent implements OnChanges {
  @Input() isEnabled = true;
  @Input() location: Location;
  @Output() readonly locationChange = new EventEmitter<Location>();

  public readonly locations$: Observable<Location[]>;
  public readonly location$ = new ReplaySubject<Location>(1);

  constructor(private readonly store: Store<Location>) {
    this.locations$ = this.store.select(CategoryStoreSelectors.selectAllCategoryEntitiesByType('Location'));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.location) {
      this.location$.next(this.location);
    }
  }

  selected(location: Location) {
    this.locationChange.emit(location);
  }
}
